import { portalJson } from '../lib/portalApi';

export type ServiceApplicationPayload = {
  serviceType: string;
  companyName: string;
  bizNo: string;
  applicantName: string;
  phone: string;
  email: string;
  siteName: string;
  siteAddress: string;
  stationId?: string | null;
  stationIds?: string[] | null;
  memoFromApplicant?: string | null;
};

export type ServiceApplicationSubmitOk = {
  applicationNo: string;
  status: string;
};

export type ServiceApplicationStatus = ServiceApplicationSubmitOk & {
  serviceType: string;
  companyName: string;
  bizNo: string;
  applicantName: string;
  phone: string;
  email: string;
  siteName: string;
  siteAddress: string;
  stationId?: string | null;
  stationIds?: string[];
  memoFromApplicant?: string | null;
  submittedAt?: string | null;
  approvedAt?: string | null;
  rejectedAt?: string | null;
  activatedAt?: string | null;
  rejectionReason?: string | null;
};

export async function submitServiceApplication(
  payload: ServiceApplicationPayload
): Promise<ServiceApplicationSubmitOk> {
  const r = await portalJson<ServiceApplicationSubmitOk>('/api/portal/applications', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    throw new Error(r.message);
  }
  const d = r.data;
  if (typeof d.applicationNo !== 'string' || typeof d.status !== 'string') {
    throw new Error('서버 응답 형식이 올바르지 않습니다.');
  }
  return d;
}

export async function fetchServiceApplicationByNo(
  applicationNo: string
): Promise<ServiceApplicationStatus> {
  const enc = encodeURIComponent(applicationNo.trim());
  const r = await portalJson<ServiceApplicationStatus>(`/api/portal/applications/${enc}`, {
    method: 'GET',
  });
  if (!r.ok) {
    throw new Error(r.message);
  }
  return r.data;
}
